import React, { createContext, useState } from "react";

interface ReplicateActionContextType {
  elementId: any;
  setElementId: (elementId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const ReplicateActionContext = createContext<ReplicateActionContextType>({
  elementId: null,
  setElementId: () => {},
  showModal: false,
  setShowModal: () => {},
  loading: false,
  setLoading: () => {},
});

interface ReplicateActionProviderProps {
  children: React.ReactNode;
}

export const ReplicateActionProvider: React.FC<ReplicateActionProviderProps> = ({ children }) => {
  const [elementId, setElementId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const value = {
    elementId,
    setElementId,
    showModal,
    setShowModal,
    loading,
    setLoading,
  };

  return (
    <ReplicateActionContext.Provider value={value}>
      {children}
    </ReplicateActionContext.Provider>
  );
};
